import { useEffect, useRef } from 'react';

export function useSwiperEvents(
  swiperRef: React.RefObject<any>,
  onIndex: (idx: number) => void,
  onTimeLeft?: (msLeft: number, ratioLeft: number) => void,
) {
  const idxCb = useRef(onIndex);
  const timeCb = useRef(onTimeLeft);
  const prev = useRef(-1);

  useEffect(() => { idxCb.current = onIndex; }, [onIndex]);
  useEffect(() => { timeCb.current = onTimeLeft; }, [onTimeLeft]);

  useEffect(() => {
    const el = swiperRef.current;
    if (!el) return;

    // index change event
    const idxHandler: EventListener = (evt) => {
      const [swiper] = (evt as CustomEvent<[any]>).detail;
      const idx = swiper.realIndex;
      if (idx !== prev.current) {
        prev.current = idx;
        idxCb.current(idx);
      }
    };
    el.addEventListener('swiperactiveindexchange', idxHandler);

    // autoplay time left event
    let autoHandler: EventListener | undefined;
    if (timeCb.current) {
      autoHandler = (evt) => {
        const [, ms, ratio] = (evt as CustomEvent<[any, number, number]>).detail;
        timeCb.current?.(ms, ratio);
      };
      el.addEventListener('swiperautoplaytimeleft', autoHandler);
    }

    return () => {
      el.removeEventListener('swiperactiveindexchange', idxHandler);
      if (autoHandler)
        el.removeEventListener('swiperautoplaytimeleft', autoHandler);
    };
  }, [swiperRef]);
}